import { render, staticRenderFns } from "./configSync.vue?vue&type=template&id=d4b8fb50&scoped=true"
import script from "./configSync.vue?vue&type=script&lang=js"
export * from "./configSync.vue?vue&type=script&lang=js"
import style0 from "./configSync.vue?vue&type=style&index=0&id=d4b8fb50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b8fb50",
  null
  
)

export default component.exports